import React from "react";
import { Check, Minus, MapPin } from "lucide-react";
import { USERS, canAccessRoute } from "../../../lib/users";
import { useRole } from "../../../lib/role.jsx";
import { cn } from "../../../lib/utils";

const SCREENS = [
  ["/", "Command Center"], ["/morning-brief", "Morning Brief"], ["/inventory", "Inventory Intelligence"],
  ["/forecast", "Forecast / Prediction Models"], ["/admin/data-management", "Data Management"], ["/admin/classification", "Classification Rules"],
  ["/admin/api-keys", "API Keys"], ["/admin/modules", "Module Visibility"],
];

// Role × screen access straight from the platform's access matrix; the signed-in role is highlighted.
export function RoleMatrix() {
  const { user } = useRole();
  return (
    <table className="w-full min-w-[560px] text-[11.5px]" data-testid="kc-diagram-roles">
      <thead>
        <tr className="border-b border-border">
          <th className="text-left py-1.5 pr-2 font-semibold text-muted text-[10.5px] uppercase tracking-wider">Role</th>
          {SCREENS.map(([p, l]) => <th key={p} className="px-1 py-1.5 font-medium text-muted text-[10.5px] leading-tight text-center align-bottom">{l}</th>)}
        </tr>
      </thead>
      <tbody>
        {USERS.map(u => (
          <tr key={u.role} data-testid={`kc-roles-${u.role}`} className={cn("border-b border-border/60", u.role === user?.role && "bg-primary/[0.07]")}>
            <td className="py-1.5 pr-2 whitespace-nowrap font-medium">{u.roleShort}{u.role === user?.role && <span className="ml-1.5 text-[9.5px] text-primary uppercase tracking-wider">you</span>}</td>
            {SCREENS.map(([p]) => {
              const ok = canAccessRoute(u.role, p);
              const branch = ok && u.branchId && p !== "/";
              return (
                <td key={p} className="text-center py-1.5">
                  {branch ? <span title="Own branch only" className="inline-flex items-center gap-0.5 text-warning"><MapPin size={11} /><span className="text-[9.5px]">own</span></span>
                    : ok ? <Check size={13} className="inline text-success" /> : <Minus size={12} className="inline text-subtle/60" />}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
